import React from 'react';
import BrandLoader from './BrandLoader';
import { colors } from '../theme/tokens';

/** The loader alone, centred on an empty page: boot and page-chunk loading. */
const FullScreenLoader = () => (
  <div
    style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: colors.bgBody,
    }}
  >
    <BrandLoader size={112} />
  </div>
);

export default FullScreenLoader;
